import React, { useMemo } from 'react';

import { Typography } from '@mui/material';
import { IntervalObject } from 'luxon';

import CelebrateSrc from '@common/assets/emojies/celebrate.webp';
import fireSrc from '@common/assets/emojies/fire.webp';
import HeartSrc from '@common/assets/emojies/heart.webp';
import LikeSrc from '@common/assets/emojies/like.webp';
import MonocleSrc from '@common/assets/emojies/monocle.webp';

import {
	StyledDayColumnHeaderCell,
	StyledDayColumnHeaderEmoji,
	StyledDayColumnWrap,
	StyledHourSlotWrap,
} from './styled';

interface DayColumnProps {
	day: IntervalObject;
	renderHour: (hour: number, day: IntervalObject) => React.ReactNode;
	maxHour?: number;
	minHour?: number;
}

const emojies = [fireSrc, LikeSrc, MonocleSrc, HeartSrc, CelebrateSrc];

function DayColumn({ day, renderHour, maxHour = 24, minHour = 0 }: DayColumnProps) {
	const hours = useMemo(
		() =>
			[...new Array(24)].map((_, key) => key).filter((hour) => hour >= minHour && hour <= maxHour),
		[maxHour],
	);

	const dayOfWeekIndex = (day.start.weekday - 1) % emojies.length;
	return (
		<StyledDayColumnWrap>
			<StyledDayColumnHeaderCell elevation={2}>
				<StyledDayColumnHeaderEmoji src={emojies[dayOfWeekIndex]} alt="emoji" />
				<Typography variant="h4">{day.start.toFormat('ccc, dd.LL')}</Typography>
			</StyledDayColumnHeaderCell>
			{hours.map((hour) => (
				<StyledHourSlotWrap key={hour}>{renderHour(hour, day)}</StyledHourSlotWrap>
			))}
		</StyledDayColumnWrap>
	);
}

export default DayColumn;
